import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../common.service';
import { ToastrService } from 'ngx-toastr';
import { DefaultComponent } from '../../layout/default/default.component';
declare var $: any;
@Component({
  selector: 'app-tithi-add',
  templateUrl: './tithi-add.component.html',
  styleUrls: ['./tithi-add.component.css']
})
export class TithiAddComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public toastr: ToastrService,
    public CommonService: CommonService,
    public DefaultComponent: DefaultComponent
  ) { }
  ngOnInit(): void {
    $('#datepicker').datepicker({
      format: "MM yyyy",
      minViewMode: 1,
      maxViewMode: 0,
      autoclose: true,
      orientation: "top",
      todayHighlight: true,
    }).on('hide', function (ev) {
      var today = ev.date;
      var mon = '';
      var month = (today.getMonth() + 1);
      var year = today.getFullYear();
      var day = 0;
      if (month == '1') { day = 31; mon = "01"; }
      if (month == '2') {
        mon = "02";
        if (year % 4 == 0) {
          day = 29;
        }
        else {
          day = 28;
        }
      }
      if (month == '3') { day = 31; mon = "03"; }
      if (month == '4') { day = 30; mon = "04"; }
      if (month == '5') { day = 31; mon = "05"; }
      if (month == '6') { day = 30; mon = "06"; }
      if (month == '7') { day = 31; mon = "07"; }
      if (month == '8') { day = 31; mon = "08"; }
      if (month == '9') { day = 30; mon = "09"; }
      if (month == '10') { day = 31; mon = "10"; }
      if (month == '11') { day = 30; mon = "11"; }
      if (month == '12') { day = 31; mon = "12"; }
      var date = '';
      for (var i = 0; i < day; i++) {
        var Tithi_date = i + 1;
        if (Tithi_date < 10) {
          var FTithi_date = '0' + Tithi_date;
        } else {
          var FTithi_date = '' + Tithi_date;
        }
        date += '<div class="col-md-6 row"><label class="col-sm-4 col-form-label">' + FTithi_date + '-' + mon + '-' + year + '</label> <div class="col-sm-8"><input type="hidden" name="ori_date" value="' + FTithi_date + '-' + mon + '-' + year + '"><input class="form-control" type="text" name="sdate" value="-"  id="datepicker" ></div></div>'
      }
      $("#date1").html(date);
    });
  }
  submit_form() {
    var routers = this.router;
    var th = this;
    $.validate({
      onSuccess: function () {
        th.DefaultComponent.loaderShow();
        $('.btn-success').attr('disabled', true);
        var form = $("#tithi_form");
        var fd = new FormData(form[0]);
        var token = localStorage.getItem('login_token');
        $.ajax({
          url: environment.GeneralBaseUrl + 'save_tithi',
          method: 'POST',
          data: fd,
          headers: {
            'Authorization': token
          },
          contentType: false,
          processData: false,
          dataType: 'json',
          success: function (res) {
            th.DefaultComponent.loaderHide();
            if (res.status) {
              th.toastr.success(res.message)
              routers.navigate(['/tithi-list']);
            } else {
              if (res.token_expire) {
                localStorage.removeItem('login_token');
                routers.navigate(['/']);
              }
              else {
                th.toastr.error(res.message)
              }
            }
            $('.btn-success').attr('disabled', false);
          }
        });
        return false;
      }
    });
  }
}
